import styled from 'styled-components';
var LogoContainer = styled.div.withConfig({
  displayName: "LogoContainer",
  componentId: "sc-1r7r9lt-0"
})(["align-items:center;display:flex;height:100%;line-height:0;"]);
export default LogoContainer;